var React = require('react');

function Comment (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\tM0.8,14.9l7.1-3.1h3c2.4,0,4.3-1.9,4.3-4.3V5.3c0-2.4-1.9-4.3-4.3-4.3H5.1C2.7,1.1,0.8,3,0.8,5.3v2.2c0,0.1,0,0.2,0,0.3\n\tc0.1,0.8,0.3,1.6,0.8,2.3L0.8,14.9z"}));
}

Comment.displayName = "Comment";

Comment.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Comment;

Comment.default = Comment;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/comment.svg
// module id = ../icon/src/icons/comment.svg
// module chunks = 0